export default "__VITE_ASSET__b7gjnUOK__"